import Utils from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { patientHasRisk } from "@/store/modules/patient/getters";
import { Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import { Atom, LabConfig } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import ProgressVertical from "../shared/ProgressVertical";

@Component({
  components: { ProgressVertical }
})
export default class Labs extends Vue {
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("showGreenGrayOnly", userNamespace)
  showGreenGrayOnly!: any;

  @Prop(Object)
  data!: Patient;

  @Prop(Boolean)
  showPopupsOnClick!: boolean;

  @Prop(String)
  displaySize!: string;

  get labArray() {
    const activeLabs: Array<any> = [];
    this.config.labConfigs.forEach((config: LabConfig) => {
      let atom: Atom = this.data.body.atoms[config.atom];
      if (!atom) {
        atom = {
          time: "",
          alert: "",
          level: 0,
          legend: "No Data",
          value: 0,
          age: 0
        };
      }

      let title = config.title;
      let legend = atom.legend;

      if (legend.includes("Hgb ") || legend.includes("Hct ")) {
        let legendList = legend.split(" ");
        if (legendList.length > 1) {
          if (config.atom !== "estHct") {
            title = legendList[0].replace(" ", "");
          }
          legend = legend.replace(legendList[0], "");
        }
      }

      let labLabelList = legend.split("|");
      if (labLabelList.length === 1) {
        labLabelList.push("");
      } else if (labLabelList.length !== 2) {
        labLabelList = ["", ""];
      }

      activeLabs.push({
        title: title,
        class: config.class,
        percent: Utils.getPercent(atom.level),
        color: Utils.getLevelColor(atom.level, this.showGreenGrayOnly),
        label: labLabelList,
        popupName: config.popupName,
        atRisk: patientHasRisk(this.data, config.risk || "")
      });
    });
    return activeLabs;
  }

  get width() {
    if (this.$vuetify.breakpoint.mdAndDown) {
      return this.small ? "10px" : "15px";
    }
    return this.small ? "10px" : "20px";
  }

  get height() {
    if (this.$vuetify.breakpoint.mdAndDown) {
      // rename small to attending or not full screen or something
      return "30px";
    } else {
      return this.small ? "30px" : "60px";
    }
  }

  get small() {
    return this.displaySize === "small";
  }
}
